import React from 'react';

import Tooltip from '../Tooltip';
import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => (
  <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
    <div className="one_half nbn-infobox__column">
      <div className="nbn-def-list">
        <dl className=" has-margin-bottom-xsmall clearfix">
          <dt>Build Started <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The date NBN began civil construction works in this rollout area</p></Tooltip></span></dt>
          <dd>{ statusDetail.build_date }</dd>
        </dl>
        <dl className=" has-margin-bottom-xsmall clearfix">
          <dt>Estimated end date <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The date NBN currently expects to complete in this rollout area. This is a forward-looking date and may be subject to change</p></Tooltip></span></dt>
          <dd>{ statusDetail.rfs_date }</dd>
        </dl>
        <dl className="clearfix">
          <dt>Rollout type <span className="relative"><Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The NBN technology and rollout type of rollout used in this rollout area</p></Tooltip></span>
            <img src="https://dvh1deh6tagwk.cloudfront.net/finder-au/wp-uploads/2020/07/powered-by-nbn-lozenge.png" className="luna-image" alt="powered by nbn" />
          </dt>
          <dd>{ statusDetail.service_type_name }</dd>
        </dl>
      </div>
      { statusDetail.last_updated
        ? <small className="fin-text-grey text-xxx-small text-center hide-mobile">Accurate as at: { statusDetail.last_updated }</small>
        : null
      }
    </div>
    <div className="one_half nbn-infobox__column">
      <LocationInfo statusDetail={statusDetail} />
      <a href={`https://www.finder.com.au/nbn-tracker/rollout/${statusDetail.region_id}`} className="btn-link nbn-btn-link">More Info</a>
    </div>
    <Disclaimer />
  </article>
);
